import { withTranslation } from "next-i18next";
import Button from "@components/core/Button";
import Image from "@components/core/Image";
import Link from "@components/core/Link";

function DrawerPostReturned({ t }) {
  return [
    <div className="drawer-body bg-white" key="drawer-closet-postreturned-body">
      <div className="d-flex flex-column align-items-center py-4 px-3 text-center">
        <h5 className="pt-2 mb-2">{t('common:drawer.modal_post_returned.your_next_closet_is_being_generated')}</h5>
        <p className="mb-4 px-5 text-gray">{t('common:drawer.modal_post_returned.your_next_closet_will_be_available_in_a_few_minutes')}</p>
        <Image
          src="lockedBagRetro"
          alt="locked-bag"
          className="mb-4"
          width={120}
          height={140}
        />
      </div>
    </div>,
    <div className="bg-white p-3 border-top" key="drawer-closet-postreturned-footer">
      <Link href={t("common:drawer.modal_closet_unavailable.contact_us.link")}>
        <Button
          fullWidth
          variant="primary"
        >
          {t("common:drawer.modal_closet_unavailable.contact_us.text")}
        </Button>
      </Link>
    </div>,
  ];
}

export default withTranslation("common")(DrawerPostReturned);
